<div class="modal-overlay" *ngIf="show">
  <div class="modal-card" [ngClass]="'modal-card--' + tipo">
    <div class="modal-card__accent"></div>
    <div class="modal-card__body">
      <div class="modal-card__icon" [ngClass]="'modal-card__icon--' + tipo">
        <i [class]="iconoPorTipo(tipo)"></i>
      </div>
      <h2 class="modal-card__title">{{ titulo }}</h2>
      <p class="modal-card__message" [innerHTML]="mensaje"></p>
      <div class="modal-card__extra">
        <ng-content></ng-content>
      </div>
      <div class="modal-card__actions">
        <button *ngIf="textoBotonCancelar" class="modal-card__btn modal-card__btn--cancel" type="button" (click)="cerrar()">
          {{ textoBotonCancelar }}
        </button>
        <button class="modal-card__btn" type="button" (click)="confirmar()">
          {{ textoBoton }}
        </button>
      </div>
    </div>
  </div>
</div>
